<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.items.length">
                <div class="grid grid-1-1 grid-1-2-m">
                  <template v-for="(item, index) in contents.items">
                    <div class="grid-item">
                      <div class="flex column fit-width">
                        <div class="quill" v-html="item.html"></div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">アイテムを追加してください</span>
                </div>
              </template>
            </div>
          </section>

        </div>
      </div>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="テキスト内容の編集" label-width="110px">
          <template v-for="(item, index) in contents.items">
            <div class="flex">
              <div class="flex column justify-center fit-width mb1">
                <div class="flex column">
                  <vue-editor v-model="item.html" :editorToolbar="customToolbar" :id="'quill-editor-' + _uid + index"></vue-editor>
                  <div class="mt1 my3 text-center">
                    <el-button class="width-20" @click="onDeleteItem(index)">アイテムの削除</el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <el-button class="my1" @click="onAddItem">アイテムの追加</el-button>
        </el-form-item>
        <!-- <el-form-item label="スマホサイズで横に並べるアイテムの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.s" controls-position="right" :min="1" :max="2"></el-input-number><span class="pl4">最大2まで</span>
        </el-form-item>
        <el-form-item label="タブレットサイズで横に並べるアイテムの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.m" controls-position="right" :min="1" :max="3"></el-input-number><span class="pl4">最大3まで</span>
        </el-form-item>
        <el-form-item label="デスクトップサイズで横に並べるアイテムの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.l" controls-position="right" :min="1" :max="4"></el-input-number><span class="pl4">最大4まで</span>
        </el-form-item> -->
        <el-form-item label="アイテム間の余白" :label-width="labelWidth">
           <el-slider v-model="contents.layout.margin" :step="1" :min="0" :max="5"></el-slider>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import ComponentBase from '@/components/mixins/ComponentBase'

export default {
  name: 'grid-rich-text-editor-1',
  mixins: [ComponentBase],
  components: {
    VueEditor
  },
  data: function () {
    return {
      labelWidth: '120px',
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{ 'align': [] }],
        [{'direction': 'rtl'}],
        [{'size': ['small', false, 'large', 'huge']}],
        [{'color': []}, {'background': []}],
        ['clean']
      ]
    }
  },
  computed: {
  },
  methods: {
    onAddItem: function () {
      this.contents.items.push({
        html: `<h1>見出し${this.contents.items.length + 1}です</h1><p>あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。</p>`
      })
    },
    onDeleteItem: function (index) {
      this.contents.items.splice(index, 1)
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const items = contents.items.reduce((acc, item, index) => {
        return acc + `<div class="grid-item"><div class="flex column fit-width">${item.html}</div></div>`
      }, '')

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <div class="grid grid-1-1 grid-1-2-m">
            ${items}
          </div>
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  }
}
</script>

<style lang="scss">
.quill {
  @import './quill.snow';
}
</style>

<style lang="scss" scoped>
.native {
  @import './GridRichTextEditor1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './GridRichTextEditor1.s.scss';
}
.tablet,
.desktop {
  @import './GridRichTextEditor1.m.scss';
}
.desktop {
  @import './GridRichTextEditor1.l.scss';
}

.ql-image {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/contents/GridRichTextEditor1/GridRichTextEditor1.vue